module.exports = __webpack_public_path__ + "img/full3-min.25388b62.png";